import React, { useContext } from "react";
import { Button } from "@mui/material";
import CustomCard from "../../styleComp/CustomCard";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Divider from "@mui/material/Divider";
import imageUrl from "../../images/two2.png";
import { RolesContext } from "../../context/User";

const NavigationCard = () => {
  const navigate = useNavigate();
  const [stateroles, dispatchroles] = useContext(RolesContext);

  // Users with priorityCode "B" (nursing home) should only see דף בית
  const isNursinghomeOnly =
    stateroles.priorityCode === "B" &&
    (stateroles.roles.includes("admin") ||
      stateroles.roles.includes("nursinghome"));

  // Users with priorityCode "D" (hospital) should only see דף בית
  const isHospitalOnly =
    stateroles.priorityCode === "D" ||
    stateroles.roles.includes("hospital");

  const navigationNavMenu = (selectedValue) => {
    navigate(`/${selectedValue}`);
  };

  const toolbarStyle = {
    ButtonCustomXL: {
      width: "150px",
      height: "50px",
      color: "white",
      display: "block",
      border: "none",
    },
    ButtonCustomMD: {
      width: "140px",
      height: "35px",
      color: "white",
      display: "block",
      border: "none",
    },
    imageStyleXL: {
      width: "15vh",
    },
    imageStyleMD: {
      width: "15vh",
      marginRight: "1.5rem",
    },
  };

  const handleButtonHover = (event) => {
    event.target.style.color = "rgb(219, 217, 217)";
    event.target.style.backgroundColor = "#65b891";
  };

  const handleButtonLeave = (event) => {
    event.target.style.color = "white";
    event.target.style.backgroundColor = "#295c9a";
  };

  return (
    <CustomCard backgroundColorStyle={"rgb(41,91,154)"} heightCard={"100%"}>
      {/* ------------------For XL desktop--------------------------- */}
      <Box
        sx={{ flexGrow: 1, display: { xs: "none", md: "none", xl: "block" } }}
      >
        <img src={imageUrl} alt="Sample" style={toolbarStyle.imageStyleXL} />
        <Typography
          sx={{
            textAlign: "center",
            color: "#65b891",
            fontWeight: "bold",
            fontSize: "22px",
            marginTop: "-0.5rem",
            marginBottom: "0.6rem",
          }}
        >
          אזור אישי
        </Typography>
        <Divider color="#3b82db" variant="middle" />
        {stateroles.roles.includes("portal") ||
        stateroles.roles.includes("admin") ? (
          <>
            <Button
              variant="outlined"
              style={toolbarStyle.ButtonCustomXL}
              onClick={() => navigationNavMenu("portal")}
              onMouseEnter={handleButtonHover}
              onMouseLeave={handleButtonLeave}
            >
              דף בית
            </Button>
            <Divider color="#3b82db" variant="middle" />
          </>
        ) : null}
        {(stateroles.roles.includes("linkopeninvoice") ||
          stateroles.roles.includes("admin")) &&
        stateroles.priorityCode === "A" ? (
          <>
            <Button
              variant="outlined"
              style={toolbarStyle.ButtonCustomXL}
              onClick={() => navigationNavMenu("linkopeninvoice")}
              onMouseEnter={handleButtonHover}
              onMouseLeave={handleButtonLeave}
            >
              חשבוניות לתשלום
            </Button>
            <Divider color="#3b82db" variant="middle" />
          </>
        ) : null}
        {(stateroles.roles.includes("getinvoice") ||
        stateroles.roles.includes("admin")) && !isNursinghomeOnly && !isHospitalOnly ? (
          <>
            <Button
              variant="outlined"
              style={toolbarStyle.ButtonCustomXL}
              onClick={() => navigationNavMenu("getinvoice")}
              onMouseEnter={handleButtonHover}
              onMouseLeave={handleButtonLeave}
            >
              חשבוניות וקבלות
            </Button>
            <Divider color="#3b82db" variant="middle" />
          </>
        ) : null}
        {(stateroles.roles.includes("openorder") ||
        stateroles.roles.includes("admin")) && !isNursinghomeOnly && !isHospitalOnly ? (
          <>
            <Button
              variant="outlined"
              style={toolbarStyle.ButtonCustomXL}
              onClick={() => navigationNavMenu("openorder")}
              onMouseEnter={handleButtonHover}
              onMouseLeave={handleButtonLeave}
            >
              הזמנות
            </Button>
            <Divider color="#3b82db" variant="middle" />
          </>
        ) : null}
        {(stateroles.roles.includes("shipping") ||
        stateroles.roles.includes("admin")) && !isNursinghomeOnly && !isHospitalOnly ? (
          <>
            <Button
              variant="outlined"
              style={toolbarStyle.ButtonCustomXL}
              onClick={() => navigationNavMenu("shipping")}
              onMouseEnter={handleButtonHover}
              onMouseLeave={handleButtonLeave}
            >
              תעודות משלוח
            </Button>
            <Divider color="#3b82db" variant="middle" />
          </>
        ) : null}
        {(stateroles.roles.includes("roles") ||
        stateroles.roles.includes("admin")) && !isNursinghomeOnly && !isHospitalOnly ? (
          <>
            <Button
              variant="outlined"
              style={toolbarStyle.ButtonCustomXL}
              onClick={() => navigationNavMenu("roles")}
              onMouseEnter={handleButtonHover}
              onMouseLeave={handleButtonLeave}
            >
              הרשאות
            </Button>
            <Divider color="#3b82db" variant="middle" />
          </>
        ) : null}
        {!isNursinghomeOnly && !isHospitalOnly && (
          <Button
            variant="outlined"
            style={toolbarStyle.ButtonCustomXL}
            onClick={() => navigationNavMenu("about")}
            onMouseEnter={handleButtonHover}
            onMouseLeave={handleButtonLeave}
          >
            מידע נוסף
          </Button>
        )}
      </Box>

      {/* ------------------For MD desktop (laptop) --------------------------- */}
      <Box
        sx={{ flexGrow: 1, display: { xs: "none", md: "block", xl: "none" } }}
      >
        <img src={imageUrl} alt="Sample" style={toolbarStyle.imageStyleMD} />
        <Typography
          sx={{
            textAlign: "center",
            color: "#65b891",
            fontWeight: "bold",
            fontSize: "18px",
            marginTop: "-0.5rem",
            marginBottom: "0.6rem",
          }}
        >
          אזור אישי
        </Typography>
        <Divider color="#3b82db" variant="middle" />
        {stateroles.roles.includes("portal") ||
        stateroles.roles.includes("admin") ? (
          <>
            <Button
              variant="outlined"
              style={toolbarStyle.ButtonCustomMD}
              onClick={() => navigationNavMenu("portal")}
              onMouseEnter={handleButtonHover}
              onMouseLeave={handleButtonLeave}
            >
              דף בית
            </Button>
            <Divider color="#3b82db" variant="middle" />
          </>
        ) : null}
        {(stateroles.roles.includes("linkopeninvoice") ||
          stateroles.roles.includes("admin")) &&
        stateroles.priorityCode === "A" ? (
          <>
            <Button
              variant="outlined"
              style={toolbarStyle.ButtonCustomMD}
              onClick={() => navigationNavMenu("linkopeninvoice")}
              onMouseEnter={handleButtonHover}
              onMouseLeave={handleButtonLeave}
            >
              חשבוניות לתשלום
            </Button>
            <Divider color="#3b82db" variant="middle" />
          </>
        ) : null}
        {(stateroles.roles.includes("getinvoice") ||
        stateroles.roles.includes("admin")) && !isNursinghomeOnly && !isHospitalOnly ? (
          <>
            <Button
              variant="outlined"
              style={toolbarStyle.ButtonCustomMD}
              onClick={() => navigationNavMenu("getinvoice")}
              onMouseEnter={handleButtonHover}
              onMouseLeave={handleButtonLeave}
            >
              חשבוניות וקבלות
            </Button>
            <Divider color="#3b82db" variant="middle" />
          </>
        ) : null}
        {(stateroles.roles.includes("openorder") ||
        stateroles.roles.includes("admin")) && !isNursinghomeOnly && !isHospitalOnly ? (
          <>
            <Button
              variant="outlined"
              style={toolbarStyle.ButtonCustomMD}
              onClick={() => navigationNavMenu("openorder")}
              onMouseEnter={handleButtonHover}
              onMouseLeave={handleButtonLeave}
            >
              הזמנות
            </Button>
            <Divider color="#3b82db" variant="middle" />
          </>
        ) : null}
        {(stateroles.roles.includes("shipping") ||
        stateroles.roles.includes("admin")) && !isNursinghomeOnly && !isHospitalOnly ? (
          <>
            <Button
              variant="outlined"
              style={toolbarStyle.ButtonCustomMD}
              onClick={() => navigationNavMenu("shipping")}
              onMouseEnter={handleButtonHover}
              onMouseLeave={handleButtonLeave}
            >
              תעודות משלוח
            </Button>
            <Divider color="#3b82db" variant="middle" />
          </>
        ) : null}
        {(stateroles.roles.includes("roles") ||
        stateroles.roles.includes("admin")) && !isNursinghomeOnly && !isHospitalOnly ? (
          <>
            <Button
              variant="outlined"
              style={toolbarStyle.ButtonCustomMD}
              onClick={() => navigationNavMenu("roles")}
              onMouseEnter={handleButtonHover}
              onMouseLeave={handleButtonLeave}
            >
              הרשאות
            </Button>
            <Divider color="#3b82db" variant="middle" />
          </>
        ) : null}
        {!isNursinghomeOnly && !isHospitalOnly && (
          <Button
            variant="outlined"
            style={toolbarStyle.ButtonCustomMD}
            onClick={() => navigationNavMenu("about")}
            onMouseEnter={handleButtonHover}
            onMouseLeave={handleButtonLeave}
          >
            מידע נוסף
          </Button>
        )}
      </Box>
    </CustomCard>
  );
};

export default NavigationCard;